import React from 'react';
import PropTypes from 'prop-types';
import { Actions as GenericAssetPortalActions } from '@mulesoft/exchange-ui-portals-common';

const AssetPortalActions = ({ portalConfiguration, ...props }) => {
  const actions = () =>
    portalConfiguration.actions({
      ...props,
      section: 'portal'
    });

  const shareModalConfiguration = {
    ShareToPublicPortalInformation:
      portalConfiguration.callouts?.ShareToPublicPortalInformation,
    ShareToPublicPortalCallout:
      portalConfiguration.callouts?.ShareToPublicPortalCallout,
    ShareWithIdentitiesCallout:
      portalConfiguration.callouts?.ShareWithIdentitiesCallout
  };

  return (
    <GenericAssetPortalActions
      actions={actions}
      shareModalConfiguration={shareModalConfiguration}
      {...props}
    />
  );
};

AssetPortalActions.propTypes = {
  portalConfiguration: PropTypes.object
};

export default AssetPortalActions;
